export enum QUANTITY_SELECTOR_ERRORS {
    MIN = 'min',
    MAX = 'max',
    INVALID = 'invalid',
}
